<template>
  <div>
    <van-nav-bar title="验证客户手机号" left-text="返回" left-arrow @click-left="onClickCheckLeft" fixed>
    </van-nav-bar>

    <div style="margin-top: 55px;">
      <van-field v-model="mobile" type="text" label="手机号" placeholder="请输入手机号" :error-message="mobile_error"
        icon="clear" @click-icon="mobile = ''" />
      <van-button size="large" type="danger" class="pop_button" @click="onCheckMobile">验证</van-button>
    </div>


    <van-cell-group v-if="info.mobile">
      <h2 class="van-doc-demo-block__title">基本信息</h2>
      <div class="van-panel__header van-hairline--bottom">
        <span class="van-panel__desc">
          <van-row gutter="4">
            <van-col span="24">姓名: {{ info.name }}</van-col>
          </van-row>
          <van-row gutter="20">
            <van-col span="12">电话: {{ info.mobile }}</van-col>
            <van-col span="7">
              状态:
              <status-tag :status="info.status" :status_color="info.status_color"
                :status_text="info.status_text"></status-tag>
            </van-col>
            <van-col span="5">
              等级:
              <labels-tag :labels="info.labels" :labels_color="info.labels_color"
                :labels_text="info.labels_text"></labels-tag>
            </van-col>
          </van-row>
          <van-row gutter="20">
            <van-col span="12">置业顾问: {{ info.employee_text }}</van-col>
            <van-col span="12">跟进时间: {{ info.save_time }}</van-col>
          </van-row>
          <van-row gutter="20">
            <van-col span="12">约访时间: {{ info.log_time }}</van-col>
            <van-col span="12">报备时间: {{ info.created_at }}</van-col>
          </van-row>
          <van-row gutter="20">
            <van-col span="12">来访时间: {{ info.come_time }}</van-col>
            <van-col span="12">成交时间: {{ info.success_time }}</van-col>
          </van-row>
          <van-row gutter="4">
            <van-col span="24">关键词: {{ info.keyword }}</van-col>
          </van-row>
          <van-row gutter="4">
            <van-col span="24">主推产品: <van-tag v-if="info.subject_text"
                style="background-color: #c9c9c9">{{ info.subject_text }}</van-tag></van-col>
          </van-row>
          <van-row gutter="20">
            <van-col span="24">最新跟进: {{ info.log_content }}</van-col>
          </van-row>
          <van-row gutter="20" v-if="info.log_content !== info.best_log_content">
            <van-col span="24">最佳跟进: {{ info.best_log_content }}</van-col>
          </van-row>
        </span>
      </div>

      <h2 class="van-doc-demo-block__title">微信相关</h2>
      <div class="van-panel__header van-hairline--bottom">
        <span class="van-panel__desc">
          <van-row gutter="4">
            <van-col span="16">微信号: {{ info.wechat }}</van-col>
            <van-col span="8">是否添加: {{ info.wechat_status_text }}</van-col>
          </van-row>
          <van-row gutter="4">
            <van-col span="24">微信昵称: {{ info.wechat_nickname }}</van-col>
          </van-row>
          <van-row gutter="4">
            <van-col span="24">添加时间: {{ info.wechat_add_time }}</van-col>
          </van-row>
        </span>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
  import StatusTag from '../../components/status-tag'
  import LabelsTag from '../../components/labels-tag'
  export default {
    components: {
      StatusTag,
      LabelsTag,
    },
    data() {
      return {
        mobile: "",
        mobile_error: "",
        info: [],
      };
    },
    methods: {
      onClickCheckLeft() {
        this.$router.push('/customer')
      },
      onCheckMobile() {
        let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.mobile)) {
          this.$toast("手机格式不对")
          return
        }
        //验证手机号
        this.$api.post('/api/customer/check', {
          mobile: this.mobile
        }, r => {
          if (r.check) {
            this.$router.push('/customer/create/' + this.mobile)
          } else {
            if (r.info.is_my) {
              this.$router.push('/customer/edit/' + r.info.id + '/customer');
            } else {
              this.info = r.info
            }
          }
        })
      }
    },
  }
</script>

<style scoped>
  .pop_button {
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/check.vue